import { Pipe, PipeTransform } from '@angular/core'

@Pipe({
    name: 'email_type',
})
export class EmailTypeFilterPipe implements PipeTransform {
    transform(type: number) {
        if (type == 0) {
            return 'Secure Email'
        } else if (type == 1) {
            return 'Secure Document Request'
        } else if (type == 2) {
            return 'Signature Request'
        }
        return type
    }
}
